module.exports = __webpack_public_path__ + "img/myguard_about_04.1b42a7ba.png";